<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 4.8654970760233915 38"
    style="max-height: 500px"
    width="4.8654970760233915"
    :height="size"
  >
    <defs>
      <filter
        id="topLeftShadow"
        x="-20%"
        y="-20%"
        width="150%"
        height="150%"
      >
        <feOffset
          dx="-2"
          dy="2"
        />
        <feGaussianBlur stdDeviation="3.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.533
                  0 0 0 0 0.596
                  0 0 0 0 0.667
                  0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          result="shape"
        />
      </filter>
    </defs>
    <path
      :stroke="strokeColor"
      :filter="hovered && 'url(#topLeftShadow)'"
      fill="white"
      d="M0.5 6.07143C0.5 3.27056 2.77056 1 5.57143 1H52.1734C54.0852 1 55.8345 2.07507 56.698 3.78068L63.2798 16.7807C64.0089 18.2208 64.0089 19.922 63.2798 21.3622L56.698 34.3622C55.8345 36.0678 54.0852 37.1429 52.1734 37.1429H5.57142C2.77055 37.1429 0.5 34.8723 0.5 32.0714V6.07143Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'ArrowLeftRounded',
  props: {
    size: {
      type: [String, Number],
      default: 38,
    },
    strokeColor: {
      type: String,
      default: '#F0F1F3',
    },
    hovered: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss"></style>
